'use strict';

import LocationsList from './locations.list.ctrl';
import NewLocation from './locations.new.ctrl';
import EditLocation from './edit/editLocation.js';

export default angular
  .module('main.locations', [
    LocationsList,
    NewLocation,
    EditLocation
  ])
  .name;
